import { Network } from '@capacitor/network';

export async function getNetworkStatus() {
  return Network.getStatus();
}

export function onNetworkChange(callback: (connected: boolean) => void) {
  Network.addListener('networkStatusChange', (status) => {
    callback(status.connected);
  });
}
